import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import StorageService from '../../services/Storage';
import AuthService from '../../services/AuthService';
import ComponetWithHeader from '../CompentWithHeader/ComponetWithHeader';
import ComponentWithoutHeader from '../ComponentWithoutHeader/ComponentWithoutHeader';
import ComponentWithoutSideNav from '../ComponentWithoutSideNav/ComponentWithoutSideNav';
import { Roles } from '../../constants/constant.role';

/**
 * onboarding route component - for first-time users
 */
const OnBoardingRoute = ({ component: Component, sidenav, header }) => {
  const isAuthenticated = AuthService.isAuthenticated();

  if (isAuthenticated === true) {
    let userDetail = StorageService.getUserDetail();
    
    // Redirect to home if user is Fleet Manager or not first-time user
    if (
      userDetail.type === Roles.FLEET_MANAGER_ROLE || 
      userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE || 
      userDetail.is_login_first_time === false
    ) {
      return <Navigate to="/" replace />;
    }

    // Render with appropriate layout
    if (header === true && sidenav === true) {
      return <ComponetWithHeader component={Component} />;
    } else if (header === true && sidenav === false) {
      return <ComponentWithoutSideNav component={Component} />;
    } else {
      return <ComponentWithoutHeader component={Component} />;
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};

OnBoardingRoute.propTypes = {
  component: PropTypes.any.isRequired,
};

export default OnBoardingRoute;
